import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { ViewUploadedDocumentsComponent } from './view-uploaded-documents.component';
import { Routes, RouterModule } from '@angular/router';
import { PendingChangesGuard } from '../../pending-changes.guard';
import { MatListModule } from '@angular/material';

const routes: Routes = [
  { path: '', component: ViewUploadedDocumentsComponent },
];

@NgModule({
  declarations: [
    ViewUploadedDocumentsComponent,
  ],
  imports: [
    SharedModule,
    CommonModule,
    MatListModule,
    RouterModule.forChild(routes)
  ],
  providers: [],
  entryComponents: [],
  bootstrap: [],
  exports: [RouterModule]
})
export class ViewUploadedDocumentsModule { }



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/view-uploaded-documents/view-uploaded-documents.module.ts